/**
 * A simple drop down built on `select`
 */
import * as React from 'react';
import * as typestyle from 'typestyle';
import * as csstips from 'csstips';
import { NestedCSSProperties } from 'typestyle/lib/types';
import { colors, fontFamily } from './styles';


export namespace SelectStyles {
  export const color = colors.grey;
  export const borderColorNormal = colors.warmGrey3
  export const borderColorOnFocus = colors.warmGrey4;
  export const errorColor = colors.red;

  export const root = {
    display: 'flex',
    flex: '1',
    width: '100%',

    height: 40,
    lineHeight: 'normal',
    padding: '7px 10px',
    color: color,
    border: `1px solid ${borderColorNormal}`,
    background: '#fff',
    borderRadius: 3,
    outline: 'none',

    transition: 'color .2s',
    fontFamily: fontFamily.arial,
  };

  export const rootClassName = typestyle.style(root, {
    $nest: {
      '&:hover': {
        borderColor: borderColorOnFocus,
      },
      '&:focus': {
        borderColor: borderColorOnFocus,
        borderWidth: 2,
        padding: '6px 9px'
      }
    }
  });

  // https://app.frontify.com/d/zYF6HCW0aIp5/ui-library#/forms/radio-buttons
  export const radioRootClassName = typestyle.style(csstips.horizontallySpaced(24) as NestedCSSProperties);

  export const radioLabelClassName = typestyle.style({
    color: colors.headingColor
  });

  export const radioInputClassName = typestyle.style({
    marginRight: '10px'
  })
}

interface Props<T> {
  values: T[],
  value: T,
  onChange: (value: T) => any,
  getId: (item: T) => string,
  getText: (item: T) => string,
  error?: string,
  id?: string,
  name?: string,
}
export class DropDownMenu<T> extends React.Component<Props<T>, {}> {
  render() {
    const {getText, getId, value, values, onChange, error} = this.props;
    const style = error
      ? {
        color: SelectStyles.errorColor,
        borderColor: SelectStyles.errorColor
      }
      : {};
    return (
      <select
        id={this.props.id}
        className={SelectStyles.rootClassName}
        style={style}
        value={getId(value)}
        onChange={(e) => {
          const id = (e.target as any).value;
          const item = values.filter(v => getId(v) === id)[0];
          onChange(item);
        } }>
        {values.map(v => <option key={getId(v)} value={getId(v)}>{getText(v)}</option>)}
      </select>
    );
  }
}

export function renderDropDownMenu<T>(props: Props<T>) {
  return <DropDownMenu {...props as any} />;
}

export class RadioGroup<T> extends React.Component<Props<T>, {}> {
  render() {
    const {getText, getId, value, values, onChange, error} = this.props;

    const style = error
      ? {
        color: SelectStyles.errorColor,
        borderColor: SelectStyles.errorColor
      }
      : {};

    return (
      <div
        id={this.props.id}
        className={SelectStyles.radioRootClassName}
        style={style}>
        {values.map(v => <label key={getId(v)} className={SelectStyles.radioLabelClassName}>
          <input type="radio" value={getId(v)} className={SelectStyles.radioInputClassName}
            checked={getId(value) === getId(v)}
            onChange={(e) => {
              const id = (e.target as any).value;
              const item = values.filter(v => getId(v) === id)[0];
              onChange(item);
            } } />
          {getText(v)}
        </label>)}
      </div>
    );
  }
}

export function renderRadioGroup<T>(props: Props<T>) {
  return <RadioGroup {...props as any} />;
}
